import { Endpoints } from '@/api/ApiEndpoints';
import { MissionTypes } from '@/constants/MissionTypes';
import { formatDate } from "@/core/helpers/DatetimeConverter";
const d = new Date();
const month = d.getMonth()+1 as any;
const lastDayOfMonth = new Date(d.getFullYear(), d.getMonth()+1, 0);
const MissionsMap = {
	Plural: 'Missions',
	Single: 'Mission',
	DefaultSorting: 'ID',
	DefaultSortingType: 'desc',
	ModalForm: false,
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'Id',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'title',
			dbName: 'title',
			label: 'Title',
			sortable: true,
			required: true,
			type: 'text',
		},
		
		{
			name: 'type',
			label: 'Type',
			required: true,
			type: 'text',
			format:(item) => {
				return  item.type;
			}
			
		},
		{
			name: 'category',
			label: 'Category',
			required: true,
			type: 'text',
			format:(item) => {
				return  item.category;
			}
			
		},
		{
			name: 'rewardCoins',
			label: 'Coins',
			required: true,
			type: 'text',
			format:(item) => {
				return  item.rewardCoins;
			}
			
		},
		{
			name: 'isActive',
			label: 'Status',
			nameToRequest: 'IsActive',
			type: 'text',
			format:(item) => {
				return  item.isActive == true ? 'Active':"InActive";
			}
		},
	],
	Filters: [
		
		{
			name: 'Category',
			label: 'Category',
			nameToRequest: 'Category',
			type: 'radioButtonWithStaticValues',
			attributes: {
				type: 'staticValue',
				values:['Daily','Longterm']				
			},
		},
		
	],
	PrimaryKey: 'id',
	Actions: {
		addLink: '/missions/add/',
		editLink: '/missions/edit/',
		deleteLink: '/missions/delete/',
	},
};

export default MissionsMap;